module.exports = __webpack_public_path__ + "assets/notifications-24-px.cf9616d8.svg";